import { environment } from './environment'

const API_ROOT = environment.API_ROOT

export const makeFullApiUrl = (fullOrRelativeUrl: string = '', apiBaseUrl: string = API_ROOT): string => {
    // if full?
    if (fullOrRelativeUrl.startsWith('http')) {
        return fullOrRelativeUrl
    }

    // get relative url
    const relativeUrl = fullOrRelativeUrl.startsWith('/') ? fullOrRelativeUrl.substring(1) : fullOrRelativeUrl

    // compose full url
    const fullUrl = apiBaseUrl + relativeUrl

    // result
    return fullUrl
}

export function getNow() {
    return new Date(new Date().setHours(0, 0, 0, 0))
}

export function setHours(date: Date, hours: number) {
    if (!date) {
        return date
    }
    return new Date(new Date(date).setHours(hours, 0, 0, 0))
}

export function InitKeys<T>(actionTypes: T) {
    for (const key in actionTypes) {
        if (Object.prototype.hasOwnProperty.call(actionTypes, key)) {
            actionTypes[key.toString()] = key.toString()
        }
    }
    return actionTypes
}
export const getApiParam = (param) => (!!param ? param : undefined)
export const getRequestParams = (params: Record<string, any>) => {
    return Object.keys(params).reduce((map, key) => {
        map[`request.${key}`] = params[key]
        return map
    }, {})
}

export const normalizeArticle = (article: string = ''): string =>
    (article ?? '').trim().replaceAll(' ', '').toLowerCase()
export const encodeArticleForPath = (article: string): string => encodeURIComponent(normalizeArticle(article))
